import React from 'react';

import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import FormViewButton from 'components/Common/Buttons/FormViewButton';

/* eslint-disable react/prop-types, react/no-unstable-nested-components */
const FormsActions = ({ permissions, settings, openAddFormModal, openAccountWithholdingModal, openDeleteFormModal, navigateToImyStructure, navigateToWithholdingStatement }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => {
    const isWhsChildAccountForm = row.original.hasParentAccount && row.original.formType.toString().toLowerCase().indexOf('w') >= 0;
    const isWhsTopLevelImyForm = !row.original.hasParentAccount && row.original.formType.toString().toLowerCase().indexOf('w8imy') >= 0
      && row.original.hasAllocationStmt && row.original.hasAllocationStmt !== 'N/A';
    const isFormExpectingWhs = row.original.formExpectsWhs === true;
    const isWhsCurrentlyEffective = row.original.whsWithinEffectiveRange === true
      && (isWhsChildAccountForm || (isWhsTopLevelImyForm && isFormExpectingWhs));
    const hasHistoricPublishedWhs = row.original.hasPublishedWhs === true;
    const showWhsRelatedIcons = hasHistoricPublishedWhs && ((isWhsChildAccountForm && row.original.hasAllocationStmt === true)
      || (isWhsTopLevelImyForm && isFormExpectingWhs));
    const whsStatusLabel = hasHistoricPublishedWhs && !isWhsCurrentlyEffective ? 'Published' : 'Draft';

    return (
      <div className="form-action-btn-group">
        { AccessControl.hasPermission(
          permissions,
          [ActivityPerms.scannedView, ActivityPerms.scannedEdit, ActivityPerms.scannedValidate]
        )
        && <FormViewButton
          content={ <span className="icon icon-apps" /> }
          className="btn btn-sm"
          title="Reopen"
          formId={ row.original.itemId }
          accountId={ row.original.accountId }
          form={ row.original }
          permissions={ permissions }
        /> }
        { AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree])
        && showWhsRelatedIcons
        && row.original.accountId
        && <button
          className="btn btn-sm"
          type="button"
          title={ `Show IMY Tree Structure (${ whsStatusLabel })` }
          onClick={ () => navigateToImyStructure(row.original) }
        ><span className="icon icon-treeview" /></button> }
        { settings?.selectedClient?.isPiiProtectionEnabled === false
        && (!row.original.isOnlineForm
          && AccessControl.hasPermission(permissions, [ActivityPerms.scannedUpload, ActivityPerms.scannedWhdStmtBoUpload], true)
        )
        && row.original.imyTier
                && (row.original.formType != null && row.original.formType.toString().toLowerCase().indexOf('w8imy') >= 0 && isFormExpectingWhs && hasHistoricPublishedWhs)
        && (row.original.hasParentAccount || (row.original.hasAllocationStmt && row.original.allocationStmtType
          && row.original.allocationStmtName.toLowerCase().indexOf('pooled') === -1))
        && <button
          className="btn btn-sm "
          onClick={ () => openAddFormModal(row.original.imyTier) }
          type="button"
          title="Add Tier"
        >
          <span className="icon icon-upload" />
        </button>}
        { AccessControl.hasPermission(permissions, [ActivityPerms.multiTierMgrViewWhs])
        && (settings && settings.showMultiTierManager)
        && showWhsRelatedIcons
        && <button
          className="btn btn-sm icon-whd-stmt"
          type="button"
          title={ `View Digital Withholding Statement (${ whsStatusLabel })` }
          onClick={ () => navigateToWithholdingStatement(row.original.accountId) }
        >WHS</button> }
        { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
                && (!row.original.hasParentAccount && !isFormExpectingWhs)
        && <button
          className="btn btn-sm"
          type="button"
          onClick={ () => openAccountWithholdingModal(row.original, 'forms') }
          title="Show Withholding Rates"
        >
          <span className="icon icon-calculator" />
        </button> }
        {
      (
        (
          row.original.isOnlineForm
          && (
            (AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteCompleteForms]) && row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
          || (AccessControl.hasPermission(permissions, [ActivityPerms.electronicDeleteInReviewForms]) && !row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
          )
        )
        || (
          !row.original.isOnlineForm
          && (
            (AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteCompleteForms]) && row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
            || (AccessControl.hasPermission(permissions, [ActivityPerms.scannedDeleteInReviewForms]) && !row.original.workflowStatus?.trim().toLowerCase().includes('complete'))
          )
          && row.original.formType
          && row.original.formType.toLowerCase() !== 'unknown'
        )
      )
        && <button
          className="btn btn-sm btn-danger"
          type="button"
          title="Delete form"
          onClick={ () => openDeleteFormModal(row.original) }
        >
          <span className="icon icon-delete" />
        </button>
      }
      </div>
    );
  },
  className: 'col-10p'
});
/* eslint-enable react/prop-types, react/no-unstable-nested-components */

export default FormsActions;
